module.exports = __webpack_public_path__ + "img/magnify.62e9bf12.png";